import React from 'react'

import './Description.scss'

export default ({ title, subTitle }) => {
    return (
        <div className="user-role-modal__description">
            {title && <h2>{title}</h2>}
            {subTitle && <h3>{subTitle}</h3>}
        </div>
    )
}
